import React from "react";
import FormattedMessage from "components/FormattedMessage";
import { Flex, H1, H2, Text, Button } from "ui-components";
import isNil from "lodash/isNil";
import get from "lodash/get";
import { gotoUrl } from "utils/helpers";
import { COLORS } from "ui-components/theme";
import * as Icons from "components/Icons";

const pageHeaderProps = {
  alignSelf: "self-start",
  flexDirection: "column"
};

const PageHeader = props => {
  const {
    title,
    subtitle,
    section_title,
    padding,
    paddingBottom,
    style = {}
  } = props;

  if (!isNil(padding)) {
    pageHeaderProps["padding"] = padding;
  } else {
    pageHeaderProps["paddingBottom"] = paddingBottom || [4, 5];
  }

  return (
    <Flex {...pageHeaderProps} style={style} data-testid="page-header">
      {title && <PageTitle {...props} />}
      {subtitle && <PageSubtitle {...props} />}
      {section_title && <PageSectionTitle {...props} />}
    </Flex>
  );
};

const PageTitle = props => {
  const {
    title,
    changeButton,
    themeColors,
    title_color,
    title_bg_color,
    title_highlight_color,
    padding_left,
    center,
    titleStyles,
    no_bg_color,
    icon,
    showStorIDValidatePopup,
    isIconHide
  } = props;
  const changeUrl = get(changeButton, "url", "");
  const iconName = get(icon, "iconName", "");
  const changeLabel = get(changeButton, "label", "change");
  const highlightColor =
    title_highlight_color || get(themeColors, "secondary", COLORS.blue[4]);
  const buttonColor = get(themeColors, "primary", COLORS.blue[4]);
  let titleStyle = { ...titleStyles } || {};
  const defaultFontStyles = {
    fontSize: "1.25rem",
    lineHeight: "1.5rem"
  };

  if (title_bg_color || !no_bg_color) {
    titleStyle = {
      backgroundColor:
        title_bg_color ||
        get(themeColors, "title.backgroundColor", COLORS.blue[4]),
      borderRadius: "0 2.5rem 2.5rem 0",
      padding: "0.5rem 1rem"
    };

    if (padding_left) {
      titleStyle["marginLeft"] = "-" + padding_left;
      titleStyle["paddingLeft"] = padding_left;
    }
  }

  titleStyle["color"] =
    title_color || get(themeColors, "title.textColor", COLORS.gray[3]);

  titleStyle = { ...defaultFontStyles, ...titleStyle, ...titleStyles }; // more flexibility in customizing title style

  var centerStyle = center
    ? {
        display: "flex",
        margin: "auto",
        justifyContent: "center",
        textAlign: "center"
      }
    : {};

  const getIcon = iconName => {
    const Icon = get(Icons, iconName, "");
    return (
      <div
        onClick={() => showStorIDValidatePopup("STORE_ID_VALIDATE_POPUP")}
        style={{ cursor: "pointer" }}
      >
        <Icon size={"30px"} color={COLORS.gray[9]} />
      </div>
    );
  };

  return (
    <Flex
      justifyContent="space-between"
      mb={2}
      data-testid="page-title"
      sx={{
        ".page-title > span > span ": { color: `${highlightColor} !important` }
      }}
    >
      <H1
        id={title}
        mb={1}
        className="page-title"
        style={{ ...titleStyle, ...centerStyle }}
      >
        <FormattedMessage html id={title} values={props} />
      </H1>
      {changeUrl && (
        <Button
          as={"a"}
          variant="closeButton"
          sx={{ fontSize: "1rem", color: buttonColor }}
          onClick={() => {
            gotoUrl(changeUrl);
          }}
        >
          <FormattedMessage id={changeLabel} />
        </Button>
      )}
      {iconName && isIconHide && getIcon(iconName)}
    </Flex>
  );
};

const PageSubtitle = props => {
  const { subtitle, themeColors, subTitleStyles = {} } = props;

  return (
    <Text
      data-testid="page-subtitle"
      sx={{
        lineHeight: "19px",
        fontSize: "16px",
        color: get(themeColors, "text", COLORS.gray[3]),
        ...subTitleStyles
      }}
      mb={1}
    >
      <FormattedMessage html id={subtitle} values={props} />
    </Text>
  );
};

const PageSectionTitle = props => {
  const { section_title } = props;

  return (
    <H2 id={section_title} data-testid="page-section-title">
      <FormattedMessage html id={section_title} values={props} />
    </H2>
  );
};

PageHeader.defaultProps = {
  title: "",
  subtitle: "",
  section_title: ""
};

export default PageHeader;
